(function () {
  const notice = document.querySelector("[data-deepmoat-cookie-notice]");
  const analyticsId = "G-KE5SREYLCH";
  let privacyApi = null;
  let analyticsStarted = false;

  function showNotice() {
    if (notice) notice.hidden = false;
  }

  function hideNotice() {
    if (notice) notice.hidden = true;
  }

  function appendScript(src, attributes) {
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    Object.entries(attributes || {}).forEach(([name, value]) => script.setAttribute(name, value));
    document.head.appendChild(script);
  }

  function startAnalytics() {
    if (analyticsStarted) return;
    analyticsStarted = true;
    window.deepmoatAnalyticsAllowed = true;
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied"
    });
    window.gtag("js", new Date());
    window.gtag("config", analyticsId, { anonymize_ip: true });
    appendScript(`https://www.googletagmanager.com/gtag/js?id=${analyticsId}`);
    appendScript("https://plausible.io/js/script.outbound-links.js", { defer: "", "data-domain": "deepmoat.ai" });
    // PostHog re-checks Customer Privacy, Do Not Track, Global Privacy Control and its theme
    // settings itself. If deepmoat-analytics.js has not run yet, it starts on load instead.
    try {
      window.deepmoatPosthog?.start();
    } catch {}
  }

  function keepNecessaryOnly() {
    window.deepmoatAnalyticsAllowed = false;
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied"
    });
  }

  function clearAnalyticsCookies() {
    const analyticsCookie = /^(?:_ga(?:_|$)|_gid$|_gat(?:_|$)|plausible(?:_|$))/i;
    const host = window.location.hostname.replace(/^www\./, "");
    const domains = ["", window.location.hostname, `.${window.location.hostname}`];
    if (host && host !== window.location.hostname) domains.push(host, `.${host}`);
    document.cookie.split(";").forEach((item) => {
      const name = item.split("=", 1)[0].trim();
      if (!analyticsCookie.test(name)) return;
      domains.forEach((domain) => {
        document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ""}`;
      });
    });
  }

  function stopAnalytics() {
    const reloadRequired = analyticsStarted;
    try {
      window.deepmoatPosthog?.stop();
    } catch {}
    keepNecessaryOnly();
    clearAnalyticsCookies();
    // A loaded analytics script cannot be unloaded safely in place. Reloading
    // after withdrawal guarantees the next document starts with consent denied
    // and never requests the analytics scripts.
    if (reloadRequired) window.location.reload();
  }

  function setConsent(allowAnalytics) {
    if (!privacyApi) return;
    privacyApi.setTrackingConsent(
      allowAnalytics
        ? { analytics: true }
        : { analytics: false, marketing: false, preferences: false },
      function () {
        if (allowAnalytics && privacyApi.analyticsProcessingAllowed()) startAnalytics();
        else stopAnalytics();
        hideNotice();
      }
    );
  }

  notice?.querySelectorAll("[data-deepmoat-consent]").forEach((button) => {
    button.addEventListener("click", () => setConsent(button.dataset.deepmoatConsent === "analytics"));
  });

  document.querySelectorAll("[data-deepmoat-open-consent]").forEach((button) => {
    button.addEventListener("click", () => {
      showNotice();
      notice?.querySelector("button")?.focus();
    });
  });

  document.addEventListener("visitorConsentCollected", (event) => {
    if (event.detail?.analyticsAllowed) startAnalytics();
    else stopAnalytics();
  });

  if (!window.Shopify?.loadFeatures) return;
  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    function (error) {
      if (error || !window.Shopify?.customerPrivacy) return;
      privacyApi = window.Shopify.customerPrivacy;
      if (privacyApi.analyticsProcessingAllowed()) startAnalytics();
      if (privacyApi.shouldShowBanner()) {
        window.setTimeout(() => {
          const shopifyBanner = document.querySelector("#shopify-pc__banner");
          const shopifyBannerVisible = shopifyBanner && window.getComputedStyle(shopifyBanner).display !== "none";
          if (!shopifyBannerVisible) showNotice();
        }, 750);
      }
    }
  );
})();
